import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div`
    margin-top: ${theme.space[2]}px;
    margin-bottom: ${theme.space[3]}px;
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 3rem;
    color: ${theme.colors.platinumDark};

    svg {
        position: relative;
        top: -2px;
        margin-left: ${theme.space[1]}px;
    }

    button {
        color: ${theme.colors.platinumDark};
        border-bottom: 1px solid ${theme.colors.platinumDark};
    }

    html[dir="rtl"] & {
        svg {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;
